<template>
  <ErrorPage code="404" />
</template>

<script>
import ErrorPage from "@/components/Common/ErrorPage.vue";

// Page not found (the router's catch-all)
export default {
  name: "PageNotFound",
  components: { ErrorPage },
};
</script>
